import { z } from "zod";

export const emptyResponseSchema = z.object({});
export const getAlmTypesResponseSchema = z.object({
  almTypes: z.array(z.record(z.any())).optional(),
});
export const startSessionResponseSchema = z.object({ started: z.boolean() });
export const getAlmItemTypeResponseSchema = z.object({ almItemType: z.record(z.any()).optional() });
export const loadAlmItemTypesResponseSchema = z.object({
  almItemTypes: z.array(z.record(z.any())).optional(),
});
export const createLinkTypeResponseSchema = z.object({ linkType: z.record(z.any()) });
export const getTeamFieldMappingsResponseSchema = z.object({
  teamFieldMappings: z.array(z.record(z.any())).optional(),
});
export const getIterationStatusResponseSchema = z.object({
  statuses: z
    .array(
      z.object({
        status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]).optional(),
        piIterationId: z.number().int().optional(),
      }),
    )
    .optional(),
});
export const startIterationSyncResponseSchema = z.object({
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
});
export const startProgramBacklogSyncResponseSchema = z.object({
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
});
export const searchAlmUsersResponseSchema = z.object({
  users: z
    .array(
      z.object({
        almId: z.string().optional(),
        pipId: z.string().optional(),
        almName: z.string().optional(),
      }),
    )
    .optional(),
});
export const getAlmUserResponseSchema = z.object({
  almId: z.string().optional(),
  pipId: z.string().optional(),
  almName: z.string().optional(),
});
export const isUserMappedResponseSchema = z.object({ isMapped: z.boolean() });
export const getProjectSourcesResponseSchema = z.object({
  projectSources: z.array(z.record(z.any())).optional(),
});
export const getMappingResponseSchema = z.object({
  mapping: z.array(z.record(z.any())).optional(),
});
export const getArtTeamFieldMappingResponseSchema = z.object({
  artTeamFieldMapping: z.record(z.any()).optional(),
});
export const getDevLinksResponseSchema = z.object({
  devLinks: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      url: z.string(),
      devStatus: z.enum(["OPEN", "MERGED", "DECLINED"]),
      source: z.string().describe("Source provider name (e.g. GitLab, GitHub)").optional(),
      branch: z.string().optional(),
      repositoryName: z.string().describe("Name of the repository the MR/PR belongs to").optional(),
      repositoryUrl: z.string().describe("URL of the repository the MR/PR belongs to").optional(),
    }),
  ),
});
